import { plainToClass } from "class-transformer";
import { WearablesEntity } from "./wearables.entities";
import { Study } from "../../../../shared/entities/scripts/study";
import { IWearablesFilteringParent, WearablesFilterSection } from "./wearables.filter";
import { Appendix } from "../../../../shared/entities/scripts/appendix";
import { Site } from "../../../../shared/entities/scripts/site";
import { SiteInfo } from "../../sites/shared/sites.entities";
import { SetActiveTab } from "../../../../shared/scripts/tab-utilities";
import { WearablesPlatformTab } from "./platform.tab";
import { WearablesSitesTab } from "./sites.tab";
import { WearablesDemographicsTab } from "./demographics.tab";
import { DateUpdatedSection } from "../../../../shared/components/date-updated-section/date-updated-section.view";

export class WearablesPage implements IWearablesFilteringParent {

    wearablesData: WearablesEntity[];

    siteInfoList: SiteInfo[];
    siteInfoMap: Map<number, SiteInfo>;

    allStudies: Study[] = [];
    allAppendices: Appendix[] = [];
    allSites: Site[] = [];

    filter: WearablesFilterSection;

    selectedGrouping: string;

    tabPlatform: WearablesPlatformTab;
    tabSite: WearablesSitesTab;
    tabDemographics: WearablesDemographicsTab;

    constructor(DataJson: any, siteInfoJson:any, LastUpdatedJson: any) {

        this.selectedGrouping = "platform";

        $(() => {

            new DateUpdatedSection(LastUpdatedJson, false, false, false, false, true);

            this.siteInfoList = SiteInfo.Parse(siteInfoJson);
            this.siteInfoMap = new Map<number, SiteInfo>();
            this.siteInfoList.forEach((site: SiteInfo) => {
                if (!this.siteInfoMap.has(site.SiteNumber)) { this.siteInfoMap.set(site.SiteNumber, site); }
            });

            this.wearablesData = plainToClass(WearablesEntity, <WearablesEntity[]>DataJson)
            this.wearablesData.forEach((entry) => entry.initialize());

            this.initializeFilters();

            this.initializeTables();

            $('#loading-indicator').hide();
            $('.loaded-content').removeClass('invisible');
        });

    }

    initializeFilters(): void {
        const foundStudyIds: number[] = [];
        const foundSiteIds: string[] = [];
        const foundAppendixIds: number[] = [];

        this.wearablesData.forEach((w) => {
            if (!foundStudyIds.includes(w.StudyId)) {
                this.allStudies.push(new Study(w.StudyId, w.StudyDisplay));
                foundStudyIds.push(w.StudyId);
            }

            if (!foundAppendixIds.includes(w.AppendixId)) {
                this.allAppendices.push(new Appendix(w.AppendixId, w.StudyId, Appendix.GetAppendixName(w.AppendixId)));
                foundAppendixIds.push(w.AppendixId);
            }

            if (!foundSiteIds.includes(w.SiteNumber + "-" + w.StudyId)) { foundSiteIds.push(w.SiteNumber + "-" + w.StudyId); }
        });

        const foundSiteMap: Map<number, Site> = new Map<number, Site>();
        this.siteInfoList.forEach((s: SiteInfo) => {
            if (foundSiteIds.includes(s.SiteNumber + "-" + s.StudyId)) {
                if (foundSiteMap.has(s.SiteNumber)) {
                    foundSiteMap.get(s.SiteNumber).StudyIds.push(s.StudyId);
                }
                else {
                    let newSite: Site = new Site(s.SiteNumber, s.getSiteNameNumber());
                    newSite.StudyIds.push(s.StudyId);
                    foundSiteMap.set(s.SiteNumber, newSite);
                }
            }
        });
        this.allSites = Array.from(foundSiteMap.values()).sort((a: Site, b: Site) => a.Name.localeCompare(b.Name));

        this.filter = new WearablesFilterSection(this.allStudies, this.allAppendices, this.allSites, this);
    }

    resetFilters(): void {
        this.filter.resetFilters();
    }

    FilterUpdated() {
        this.updateData();
    }

    setView(newView: string): void {

        if (newView === "platform") {
            SetActiveTab("wearables-datatable-tabs", "content-wearables-datatable-platform");
            // this.tableNone.columns.adjust();
        } else if (newView === "site") {
            SetActiveTab("wearables-datatable-tabs", "content-wearables-datatable-site");
            // this.tableByVisit.columns.adjust();
        } else if (newView === "demographics") {
            SetActiveTab("wearables-datatable-tabs", "content-wearables-datatable-demographics");
            // this.tableBySite.columns.adjust();
        }

        this.tabPlatform.refresh();
        this.tabSite.refresh();
        this.tabDemographics.refresh();
    }

    initializeTables(): void {
        this.tabPlatform = new WearablesPlatformTab('#wearables-datatable-platform', this.wearablesData);
        this.tabPlatform.initializeTable();

        this.tabSite = new WearablesSitesTab('#wearables-datatable-site', this.wearablesData);
        this.tabSite.initializeTable();

        this.tabDemographics = new WearablesDemographicsTab('#wearables-datatable-demographics', this.wearablesData);
        this.tabDemographics.initializeTable();

        this.updateData();
    }

    updateData(): void {
        if (!this.filter) return;

        this.tabPlatform.updateData(this.filter);
        this.tabSite.updateData(this.filter);
        this.tabDemographics.updateData(this.filter);
    }

}